import {Col, Row} from "react-bootstrap";
import React from "react";

const MarkerListPanel = ({
                           propTitle = '',
                           children
                         }) => {
  return (
      <>
        <div className={"narrow-floor-plan-container-title text-center py-2"}>
          <span>{propTitle}</span>
        </div>
        <Row>
          <Col md={12} className={"repeater-table-container pe-2"}>
            {children}
          </Col>
        </Row>
      </>
  );
}

export default MarkerListPanel;